"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bucketABTest = exports.isABTestConfig = exports.isABTestVariation = exports.audienceMatchesDeviceType = exports.AB_TEST_TYPES = exports.AB_TEST_AUDIENCE = void 0;
const seedrandom_1 = __importDefault(require("seedrandom"));
exports.AB_TEST_AUDIENCE = {
    STANDARD: 'STANDARD',
    RESPONSIVE: 'RESPONSIVE',
    MOBILE: 'MOBILE',
};
exports.AB_TEST_TYPES = {
    BUYER_CLIENT: 'BUYER_CLIENT',
    BUYER_COOKIE: 'BUYER_COOKIE',
    BUYER_USER: 'BUYER_USER',
    SELLER: 'SELLER',
    EMAIL: 'EMAIL',
    BUYER_APP_INSTANCE: 'BUYER_APP_INSTANCE',
    BUYER_APP_USER: 'BUYER_APP_USER',
    SELLER_APP: 'SELLER_APP',
    SELLER_PREBUCKET: 'SELLER_PREBUCKET',
    APP_SELLER_PREBUCKET: 'APP_SELLER_PREBUCKET',
};
/**
 * @description Check if the user's device type matches the audience type for the AB test
 * @param configAudience Audience type for the AB test
 * @param deviceType User's device type
 * @returns boolean
 */
const audienceMatchesDeviceType = (configAudience, deviceType) => {
    if (configAudience === exports.AB_TEST_AUDIENCE.STANDARD) {
        return true;
    }
    return ((configAudience === exports.AB_TEST_AUDIENCE.MOBILE && deviceType === 'mobile') ||
        (configAudience === exports.AB_TEST_AUDIENCE.RESPONSIVE &&
            (deviceType === 'desktop' || deviceType === 'tablet')));
};
exports.audienceMatchesDeviceType = audienceMatchesDeviceType;
/**
 * @description Type guard for ABTestVariation
 * @param o the value to test
 * @returns boolean
 */
const isABTestVariation = (o) => typeof (o === null || o === void 0 ? void 0 : o.value) === 'string' && typeof (o === null || o === void 0 ? void 0 : o.weight) === 'number';
exports.isABTestVariation = isABTestVariation;
/**
 * @description Type guard for ABTestConfig
 * @param o the value to test
 * @returns boolean
 */
const isABTestConfig = (o) => typeof (o === null || o === void 0 ? void 0 : o.testName) === 'string' &&
    typeof (o === null || o === void 0 ? void 0 : o.isActive) === 'boolean' &&
    typeof (o === null || o === void 0 ? void 0 : o.route) === 'string' &&
    typeof (o === null || o === void 0 ? void 0 : o.ramp) === 'number' &&
    typeof (o === null || o === void 0 ? void 0 : o.audience) === 'string' &&
    (o === null || o === void 0 ? void 0 : o.audience) in exports.AB_TEST_AUDIENCE &&
    Array.isArray(o === null || o === void 0 ? void 0 : o.variations) &&
    (o === null || o === void 0 ? void 0 : o.variations.length) > 0 &&
    (o === null || o === void 0 ? void 0 : o.variations.every(exports.isABTestVariation));
exports.isABTestConfig = isABTestConfig;
/**
 *
 * @param config AB test config object of type:
 * `{
 *   testName: string;
 *   ramp: number;
 *   variations: {
 *       value: string;
 *       weight: number;
 *   }[];
 * }`
 * @param seedBase string to base the random number generator on. This should be a unique value for the user.
 * @returns
 */
function bucketABTest(config, seedBase) {
    // cribbed heavliy from
    // https://developer.fastly.com/solutions/tutorials/ab-testing-edge-compute/#apply-the-test-to-the-current-visitor
    // seed the random number generator
    const bucketRng = (0, seedrandom_1.default)(seedBase + config.testName);
    const weightsTotal = config.variations.reduce((sum, v) => sum + v.weight, 0);
    // deterministically generate a random number between 0 and the total weight
    const ranNum = bucketRng() * weightsTotal;
    let bucketRn = ranNum;
    // find the bucket that the random number falls into
    const bucket = config.variations.find(v => {
        bucketRn = bucketRn - v.weight;
        return bucketRn < 0;
    });
    if (bucket) {
        // If the visitor falls in a bucket, are they in the ramp?
        // Create a new random number generator with the
        // vistor's bucket seeded random number
        const rampRng = (0, seedrandom_1.default)(ranNum.toString());
        // Does the new random number fall in the ramp?
        // This ensures that the same visitor will always see the same
        // variation as the ramp goes up
        if (rampRng() * 100 < config.ramp) {
            return bucket.value;
        }
    }
    return null;
}
exports.bucketABTest = bucketABTest;
